'use client';

import { HStack } from '@terra/ui-styled-system';
import { Text } from '../../../../components/styled/text';
import { EmailInboxCard } from '../../../artifacts/email/EmailInboxArtifact';
import { buildEmailInboxPayloadFromFiles } from '../../../artifacts/email/email-inbox-from-files';
import { useTraceOptional } from '../TraceFilesProvider';
import type { TraceToolCall } from '../types';

type EmailInboxToolCardProps = {
  toolCall: TraceToolCall;
  displayName: string;
};

export function EmailInboxToolCard({
  toolCall,
  displayName,
}: EmailInboxToolCardProps) {
  const { traceFiles } = useTraceOptional();
  const payload = buildEmailInboxPayloadFromFiles({
    output: toolCall.output,
    files: traceFiles.map((file) => ({
      name: file.name,
      content: file.content ?? '',
    })),
  });

  if (!payload) {
    return (
      <HStack w="full" gap={1.5} alignItems="center" py={1} borderRadius="sm">
        <Text fontSize="xs" color="fg.muted">
          {displayName}
        </Text>
      </HStack>
    );
  }

  return <EmailInboxCard payload={payload} />;
}
